import TextLabel from 'app/components/TextLabel/TextLabel';
import { LenderSummaryHeaderInterface } from 'app/interfaces/lender/LenderSummaryHeaderInterface';
import { getLenderSummaryHeaderAction } from 'app/redux/actions/PortofolioAction';
import { RootState } from 'app/redux/store';
import rupiahCurrencyFormatter from 'app/utils/RupiahPipe';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import './Marketplace.scss';
import { getTkbAction } from 'app/redux/actions/NavHeaderAction';

const Marketplace = function init(): React.ReactElement {
    const lenderSummaryState: LenderSummaryHeaderInterface = {
		lenderId: '',
		cashBalance: 0,
		outStandingBalance: 0,
		estTotalGet: 0,
		estInterestGet: 0,
        additionalCashBalance: 0
	};

    const dispatch = useDispatch();
    const portofolioState = useSelector((state: RootState) => state.portofolioReducer);
    const { lenderSummary, summaryLoading } = portofolioState;
    const [summary, setSummary] = useState(lenderSummaryState);

    useEffect(() => {
		dispatch(getTkbAction());
		dispatch(getLenderSummaryHeaderAction());
	}, []);

	useEffect(() => {
		setSummary(lenderSummary);
	}, [lenderSummary]);

    function renderCashBalance(): React.ReactElement {
        return (
            <div className="card">
                <div className="fit-content">
                    <TextLabel
                        bg
                        title="Cash Balance"
                        value={rupiahCurrencyFormatter(summary.cashBalance)}
                        key="cash-balance"
                        color="#0033A1"
                        loading={summaryLoading}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard-layout">
            {renderCashBalance()}
            <Outlet />
        </div>
    );
};

export default Marketplace;
